module.exports = __webpack_public_path__ + "static/media/galleryImage05.100f5bbf.jpg";